import { TableCell, TableRow } from "@mui/material";
import { format } from "date-fns";
import { TWChip, TWChipColor } from "apps/web/src/componentLibrary/TWChip/TWChip";
import { BulkAssignGoalTemplateJobOffsetConnectionQuery } from "apps/web/src/types";
import { BulkAssignGoalTemplateJobStatus  } from "@notemeal/graphql-types";
import { useDateFormatting } from "shared-ui/contexts/Locale/useDateFormatting";
import { Dispatch, SetStateAction } from "react";
import { SelectedJob } from ".";

type JobType = BulkAssignGoalTemplateJobOffsetConnectionQuery["bulkAssignGoalTemplateJobOffsetConnection"]["edges"][0];

const getJobStatus = (job: JobType) => {
  switch (job.status) {
    case BulkAssignGoalTemplateJobStatus.success:
      return <TWChip label="Success" chipColor={TWChipColor.green} />;
    case BulkAssignGoalTemplateJobStatus.partialSuccess:
      return <TWChip label="Partial Success" chipColor={TWChipColor.orange} />;
    case BulkAssignGoalTemplateJobStatus.failed:
      return <TWChip label="Failed" chipColor={TWChipColor.red} />;
    case BulkAssignGoalTemplateJobStatus.processing:
      return <TWChip label="In Progress" chipColor={TWChipColor.blue} />;
    case BulkAssignGoalTemplateJobStatus.queued:
    default:
      return <TWChip label="Waiting" chipColor={TWChipColor.gray} />;
  }
};

type TableBodyRowsProps = {
  job: JobType,
  setSelectedJob: Dispatch<SetStateAction<SelectedJob | undefined>>;
}

export const TableBodyRows = ({ job, setSelectedJob }: TableBodyRowsProps) => {
  const { dateFnsLocale } = useDateFormatting();
  return (
    <TableRow
      key={job.id}
      onClick={() =>
        setSelectedJob({
          id: job.id,
          name: job.goalConfigurationTemplateName,
          dateAssignment: job.dateAssignment,
        })
      }
      hover
      sx={{
        cursor: "pointer",
        height: 48,
        "&:focus-visible": {
          outline: "2px solid",
          outlineColor: "primary.main",
          outlineOffset: "-2px",
        }
      }}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setSelectedJob({
            id: job.id,
            name: job.goalConfigurationTemplateName,
            dateAssignment: job.dateAssignment,
          });
        }
      }}
    >
      <TableCell sx={{ px: 3, py: 1.5 }}>{job.goalConfigurationTemplateName}</TableCell>
      <TableCell sx={{ px: 3, py: 1.5 }}>
        {job.createdBy?.firstName} {job.createdBy?.lastName}
      </TableCell>
      <TableCell sx={{ px: 3, py: 1.5 }}>{format(new Date(job.createdAt), "P", { locale: dateFnsLocale })}</TableCell>
      <TableCell sx={{ px: 3, py: 1.5 }}>
        {job.athleteSucceededCount + job.athleteFailedCount}/{job.athleteCount}
      </TableCell>
      <TableCell sx={{ px: 3, py: 1.5 }}>{getJobStatus(job)}</TableCell>
    </TableRow>
  );
};
